import { PluginDefinition } from 'yam-types'
import certManagerOperator from './handlers/cert-manager'
import { name, version } from './package.json'
import * as schema from './schema.json'
import * as settings from './settings.json'
import { CertManagerCertificate } from './types.d'

export default {
  name,
  schema,
  settings,
  version,
  handlers: {
    'prepare[?(@.type=="cert")]': certManagerOperator
  }
} as PluginDefinition<CertManagerCertificate>